import React ,{useEffect} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import defaultStyles from './fileAvailability.module.scss';
import {fileAvailabilityConnected, refreshFileAvailability, setGridSorts} from './actions'
import GridHeader from '../../common/gridheader/GridHeader';
import Grid from '../../webcommon/grid/Grid';
import {fileAvailabilityColumns} from './constants';
import { getTimeStamp } from '../../webcommon/common/helpers';
import * as selectors from './selectors'
import {getDefaultSort,getDateFrom, getDateTo,} from './selectors'
import { findGridSort } from "../../common/helpermethods/HelperMethods"
import FilterHeader from '../../webcommon/header/filterheader/FilterHeader';
import { getFilters } from '../../webcommon/header/filterheader/selectors';

const FileAvailability = (props)=> {

    const {
        fileAvailabilityConnected,
        location        
    } = props;            

    useEffect(() => {
        fileAvailabilityConnected(location.search);
    },[fileAvailabilityConnected, location]);

    
    return (
        <div className={props.styles.wrapper}>
            <div className={props.styles.filter}>                      
                <FilterHeader
                    fixed
                    title="Data Load Filters"
                    id="FileAvailability"/>                                          
                <div>
                    <div className={props.styles.gridHeader}>
                        <GridHeader
                            title="SIMM Files Available"   
                            refreshControlsActive
                            refreshData={ props.refreshFileAvailability }  
                            lastUpdated={ props.lastUpdated } />           
                    </div>
                    <div className={props.styles.grid}>
                        <Grid
                            sortable
                            columns={fileAvailabilityColumns}
                            rows={props.rowsFileAvailability}
                            loading={ props.loading }
                            defaultSorted={ findGridSort(props.defaultSort, 'timestampSort') }
                            onSortedChange={ (newSorted) => {props.setGridSorts('timestampSort', newSorted);} }
                        />
                    </div>
                </div>                               
            </div>      
        </div>       
        ); 
}
FileAvailability.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string
    }).isRequired,
    fileAvailabilityConnected: PropTypes.func.isRequired,
    styles: PropTypes.objectOf(PropTypes.string)    
};

FileAvailability.defaultProps = {
     styles: defaultStyles,
     dateProp: '',
     lastUpdated: getTimeStamp(),
};

const mapDispatchToProps = {
    fileAvailabilityConnected,
    refreshFileAvailability,
    setGridSorts,
};

const mapStateToProps = state => ( 
    {  
        rowsFileAvailability: state.fileAvailability.rowsFileAvailability,
        loading: state.fileAvailability.loadingFileAvailability,
        lastUpdated: selectors.getFileAvailabilityLastUpdated(state),
        defaultSort: getDefaultSort(state),
        dateFrom: getDateFrom(getFilters(state, 'FileAvailability')),
        dateTo: getDateTo(getFilters(state, 'FileAvailability')),
        runDate: getDateFrom(getFilters(state, 'FileAvailability')),
    }
)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FileAvailability));
